<template>
   <Toast />
   <Layoutview v-if="showLayout" />
   <router-view v-else />
</template>
<script setup>
import { useRoute } from 'vue-router';
import { computed, onMounted } from 'vue';
import Layoutview from '@/layout/Layoutview.vue';
import { setToast } from './composables/useToast';
import { useToast } from 'primevue/usetoast';
const route = useRoute();
const showLayout = computed(() => {
   return route.name && route.meta.requiresLayout === true;
});

onMounted(() => {
   const toast = useToast();
   setToast(toast);
});
</script>

<style>
h5 {
   font-size: 1.5rem;
}
</style>
